import createBooleanSlice from './slice-factories/boolean';

const booleanShard = createBooleanSlice('reloginVisible');

export default booleanShard.reducer;

export const { actions } = booleanShard;
